module.exports = __webpack_public_path__ + "img/Bismillah.4aa30636.png";